module.exports = "/img/vdf_wizdome_logo.png?a7a45ebe735d02687af31034533aeff9";